module.exports = __webpack_public_path__ + "img/error500.76b16fc2.png";